import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, createSlots as _createSlots, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-arrow-left text-md cursor-pointer" }, null, -1);
const _hoisted_2 = [
    _hoisted_1
];
const _hoisted_3 = { class: "w-full" };
const _hoisted_4 = { class: "flex flex-row" };
const _hoisted_5 = {
    key: 0,
    class: "text-base md:text-xl lg:text-3xl truncate"
};
const _hoisted_6 = { class: "pl-1 md:text-xl lg:text-3xl" };
const _hoisted_7 = { class: "ml-1 flex flex-row items-center" };
const _hoisted_8 = { class: "block fas fa-crown text-xs ml-2" };
const _hoisted_9 = { class: "hidden md:block truncate w-96" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "md:hidden flex flex-row items-center" };
const _hoisted_12 = { class: "flex-1 my-4 flex flex-row items-center max-w-full" };
const _hoisted_13 = { class: "pl-2 max-w truncate" };
const _hoisted_14 = {
    key: 0,
    class: "inline-block"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "bg-primary rounded-full w-6 h-6 flex items-center justify-center text-white" }, [
    /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-right text-white" })
], -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = {
    key: 0,
    class: "ml-1 w-full flex flex-row"
};
const _hoisted_19 = { class: "flex flex-row justify-end w-full" };
const _hoisted_20 = { class: "hidden md:flex md:items-center" };
const _hoisted_21 = { class: "hidden md:flex md:items-center" };
const _hoisted_22 = { colspan: "4" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "mx-auto h-12 w-12 text-gray-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "vector-effect": "non-scaling-stroke",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    })
], -1);
const _hoisted_24 = { class: "hidden md:block h-full" };
const _hoisted_25 = {
    key: 2,
    class: "pr-1"
};
const _hoisted_26 = {
    key: 0,
    class: "max-w-max p-1 border-2 border-black bg-white"
};
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("em", { class: "far fa-file" }, null, -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-times text-lg" }, null, -1);
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = { class: "absolute top-0 left-0 h-full w-full border-dashed border-8 rounded-lg border-black grid place-items-center" };
export function render(_ctx, _cache) {
    const _component_work_space_dropdown = _resolveComponent("work-space-dropdown");
    const _component_Button = _resolveComponent("Button");
    const _component_plus_icon = _resolveComponent("plus-icon");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_folder_bar = _resolveComponent("folder-bar");
    const _component_admin_file_details = _resolveComponent("admin-file-details");
    const _component_admin_folder_details = _resolveComponent("admin-folder-details");
    const _component_bread_crumb = _resolveComponent("bread-crumb");
    const _component_overflow_bread_crumb = _resolveComponent("overflow-bread-crumb");
    const _component_multi_select_sidebar = _resolveComponent("multi-select-sidebar");
    const _component_file_manager = _resolveComponent("file-manager", true);
    const _component_tab_layout = _resolveComponent("tab-layout");
    const _component_create_folder_modal = _resolveComponent("create-folder-modal");
    const _component_create_file_modal = _resolveComponent("create-file-modal");
    const _component_file_upload_modal = _resolveComponent("file-upload-modal");
    const _component_folder_upload_modal = _resolveComponent("folder-upload-modal");
    const _component_delete_file_modal = _resolveComponent("delete-file-modal");
    const _component_change_item_name_modal = _resolveComponent("change-item-name-modal");
    const _component_temporary_item_share_modal = _resolveComponent("temporary-item-share-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_tab_layout, null, _createSlots({
            title: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_work_space_dropdown, null, {
                            selectedItem: _withCtx(() => [
                                (_ctx.selectedWorkspace)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedWorkspace.name), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_6, "- " + _toDisplayString(_ctx.$t('file.fileManagement')), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                                [_vShow, _ctx.$route.meta.isAdmin]
                            ])
                        ])
                    ])
                ])
            ]),
            content: _withCtx(() => [
                (!_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_file_manager, {
                        key: 0,
                        onDragenter: _ctx.dragStart,
                        onDrop: _ctx.dropFile,
                        class: "block h-full",
                        data: _ctx.itemsToShow,
                        withFiltering: "",
                        backendFiltering: "",
                        onSelectedChanged: _ctx.selectedChanged,
                        displaySidebar: _ctx.displaySidebar,
                        onOpenItem: _ctx.openItem,
                        onSearchChanged: _ctx.doSearch,
                        onDoSearch: _ctx.doSearch,
                        onMoveItems: _ctx.moveItems,
                        onStartInternalDrag: _ctx.startInternalDrag,
                        onStopInternalDrag: _ctx.stopInternalDrag,
                        dragAndDrop: _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.move }) ||
                            _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.move }),
                        headers: _ctx.headers
                    }, {
                        "data-name": _withCtx((rowData) => [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("em", {
                                    class: _normalizeClass(_ctx.getIcon(rowData.row.fileType) + ' ' + _ctx.getIconColor(rowData.row.fileType))
                                }, null, 2),
                                _createElementVNode("span", {
                                    onClick: _withModifiers(($event) => (_ctx.openItem(rowData.row)), ["stop"]),
                                    class: "ml-2 hover:underline"
                                }, _toDisplayString(_ctx.getName(rowData.row)), 9, _hoisted_10)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("em", {
                                        class: _normalizeClass(_ctx.getIcon(rowData.row.fileType) + ' ' + _ctx.getIconColor(rowData.row.fileType))
                                    }, null, 2),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(rowData.row.name), 1),
                                    (!rowData.row.isFolder)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "." + _toDisplayString(rowData.row.extension), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                (rowData.row.isFolder)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "w-12 h-full flex items-center justify-center my-4",
                                        onClick: _withModifiers(() => _ctx.openItem(rowData.row), ["stop"])
                                    }, _hoisted_17, 8, _hoisted_15))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        topRight: _withCtx(() => [
                            (_ctx.config.env.canSearchInFileContent)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_Button, {
                                        class: "mr-1",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.searchType = _ctx.SearchType.NAME), ["prevent"])),
                                        colored: _ctx.searchType === _ctx.SearchType.NAME
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('search.names')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["colored"]),
                                    _createVNode(_component_Button, {
                                        class: "mr-3",
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.searchType = _ctx.SearchType.CONTENT), ["prevent"])),
                                        colored: _ctx.searchType === _ctx.SearchType.CONTENT
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('search.content')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["colored"])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_Button, {
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showFileUpload = true)),
                                    class: "md:flex m-0 s:w-1/3 s:justify-center",
                                    colored: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_component_plus_icon, { class: "w-3 h-3 mr-2" }),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('file.uploadFile')), 1)
                                        ]),
                                        _createVNode(_component_plus_icon, { class: "block md:hidden w-5 h-5" })
                                    ]),
                                    _: 1
                                }),
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.create }))
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showFileCreation = true)),
                                        class: "hidden md:flex m-0 ml-2 s:w-1/3 s:justify-center",
                                        colored: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createVNode(_component_plus_icon, { class: "w-3 h-3 mr-2" }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('file.newFile')), 1)
                                            ]),
                                            _createVNode(_component_plus_icon, { class: "block md:hidden w-5 h-5" })
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.create }))
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 1,
                                        class: "hidden md:flex m-0 ml-2 s:w-1/3 s:justify-center",
                                        colored: "",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.showCreateFolder = true))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_plus_icon, { class: "w-3 h-3 mr-2" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('folder.createNewFolder')), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        emptyState: _withCtx(() => [
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_22, [
                                    _createVNode(_component_empty_table_state, null, {
                                        icon: _withCtx(() => [
                                            _hoisted_23
                                        ]),
                                        header: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('filter.foldersNotFound')), 1)
                                        ]),
                                        content: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('filter.addItemsMessage')), 1)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        loading: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('tables.loadingState.folderLoading')), 1)
                        ]),
                        quickAccess: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_folder_bar, {
                                    activeFolderId: _ctx.isSearching ? '' : _ctx.selectedFolderId,
                                    onOpenFolder: _ctx.openItem
                                }, null, 8, ["activeFolderId", "onOpenFolder"])
                            ])
                        ]),
                        sideBar: _withCtx(() => [
                            (_ctx.selectedItemDetails)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: _ctx.selectedItemDetails,
                                    class: "w-full z-50 md:max-w-md"
                                }, [
                                    (_ctx.selectedItemDetails['fileUuid'])
                                        ? (_openBlock(), _createBlock(_component_admin_file_details, {
                                            key: 0,
                                            fileDetails: _ctx.selectedItemDetails,
                                            onPreviewItem: _cache[6] || (_cache[6] = ($event) => (_ctx.adminSideBarActions('preview-item'))),
                                            onWriteItem: _cache[7] || (_cache[7] = ($event) => (_ctx.adminSideBarActions('write-item'))),
                                            onDownloadItem: _cache[8] || (_cache[8] = ($event) => (_ctx.adminSideBarActions('download-item'))),
                                            onDeleteItem: _cache[9] || (_cache[9] = ($event) => (_ctx.adminSideBarActions('delete-item'))),
                                            onSaveItem: _cache[10] || (_cache[10] = ($event) => (_ctx.adminSideBarActions('save-item'))),
                                            onMountItem: _cache[11] || (_cache[11] = ($event) => (_ctx.adminSideBarActions('mount-item'))),
                                            onShareItem: _cache[12] || (_cache[12] = ($event) => (_ctx.adminSideBarActions('share-item'))),
                                            onCollapseSidebar: _ctx.collapseSidebar
                                        }, null, 8, ["fileDetails", "onCollapseSidebar"]))
                                        : _createCommentVNode("", true),
                                    (_ctx.selectedItemDetails['folderUuid'])
                                        ? (_openBlock(), _createBlock(_component_admin_folder_details, {
                                            key: 1,
                                            folderDetails: _ctx.selectedItemDetails,
                                            onOpenFolder: _ctx.openItem,
                                            onEditFolderName: _cache[13] || (_cache[13] = ($event) => (_ctx.adminSideBarActions('write-item'))),
                                            onDeleteItem: _cache[14] || (_cache[14] = ($event) => (_ctx.adminSideBarActions('delete-item'))),
                                            onMountItem: _cache[15] || (_cache[15] = ($event) => (_ctx.adminSideBarActions('mount-item'))),
                                            onShareItem: _cache[16] || (_cache[16] = ($event) => (_ctx.adminSideBarActions('share-item'))),
                                            onCollapseSidebar: _ctx.collapseSidebar
                                        }, null, 8, ["folderDetails", "onOpenFolder", "onCollapseSidebar"]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        breadcrumb: _withCtx(() => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["relative w-full flex items-center", [_ctx.isSearching ? 'justify-end' : 'justify-between']])
                            }, [
                                (!_ctx.isSearching && (_ctx.breadcrumbValues.length < 6 || _ctx.isMobile()))
                                    ? (_openBlock(), _createBlock(_component_bread_crumb, {
                                        key: 0,
                                        folders: _ctx.breadcrumbValues,
                                        onOpenFolder: _ctx.openFolderById
                                    }, null, 8, ["folders", "onOpenFolder"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isSearching && _ctx.breadcrumbValues.length >= 6 && !_ctx.isMobile())
                                    ? (_openBlock(), _createBlock(_component_overflow_bread_crumb, {
                                        key: 1,
                                        folders: _ctx.breadcrumbValues,
                                        onOpenFolder: _ctx.openFolderById
                                    }, null, 8, ["folders", "onOpenFolder"]))
                                    : _createCommentVNode("", true),
                                (_ctx.displayMultiFileSidebar)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(_component_multi_select_sidebar, {
                                            colorIcon: true,
                                            onPreviewItem: _cache[17] || (_cache[17] = ($event) => (_ctx.adminSideBarActions('preview-item'))),
                                            onDownloadItem: _cache[18] || (_cache[18] = ($event) => (_ctx.adminSideBarActions('download-item'))),
                                            onDeleteItem: _cache[19] || (_cache[19] = ($event) => (_ctx.adminSideBarActions('delete-item'))),
                                            onMountItem: _cache[20] || (_cache[20] = ($event) => (_ctx.adminSideBarActions('mount-item'))),
                                            onShareItem: _cache[21] || (_cache[21] = ($event) => (_ctx.adminSideBarActions('share-item')))
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 2)
                        ]),
                        "dragging-indicator": _withCtx(() => [
                            (_ctx.isInternalDragging)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _hoisted_27,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.movingItem')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["onDragenter", "onDrop", "data", "onSelectedChanged", "displaySidebar", "onOpenItem", "onSearchChanged", "onDoSearch", "onMoveItems", "onStartInternalDrag", "onStopInternalDrag", "dragAndDrop", "headers"]))
                    : _createCommentVNode("", true)
            ]),
            _: 2
        }, [
            (_ctx.isAdmin)
                ? {
                    name: "leftButton",
                    fn: _withCtx(() => [
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'AdminVaultsOverview' })))
                        }, _hoisted_2)
                    ])
                }
                : undefined
        ]), 1024),
        (_ctx.isDragging)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onDragleave: _cache[23] || (_cache[23] =
                    //@ts-ignore
                    (...args) => (_ctx.dragStop && _ctx.dragStop(...args))),
                onDragover: _cache[24] || (_cache[24] = _withModifiers(() => { }, ["prevent"])),
                onDrop: _cache[25] || (_cache[25] =
                    //@ts-ignore
                    (...args) => (_ctx.dropFile && _ctx.dropFile(...args))),
                class: "fixed top-0 left-0 h-full w-full bg-gray-200 bg-opacity-75 p-4 z-50"
            }, [
                _createElementVNode("div", {
                    class: "absolute right-2 top-4 md:right-6 md:top-6 cursor-pointer z-10 px-2",
                    onClick: _cache[22] || (_cache[22] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.dragStop && _ctx.dragStop(...args)), ["stop"]))
                }, _hoisted_29),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('file.dropToUpload')), 1)
            ], 32))
            : _createCommentVNode("", true),
        (_ctx.showCreateFolder)
            ? (_openBlock(), _createBlock(_component_create_folder_modal, {
                key: 1,
                show: _ctx.showCreateFolder,
                "onUpdate:show": _cache[26] || (_cache[26] = ($event) => ((_ctx.showCreateFolder) = $event)),
                onSetFolder: _ctx.addNewFolder
            }, null, 8, ["show", "onSetFolder"]))
            : _createCommentVNode("", true),
        (_ctx.showFileCreation)
            ? (_openBlock(), _createBlock(_component_create_file_modal, {
                key: 2,
                show: _ctx.showFileCreation,
                "onUpdate:show": _cache[27] || (_cache[27] = ($event) => ((_ctx.showFileCreation) = $event)),
                view: _ctx.viewType
            }, null, 8, ["show", "view"]))
            : _createCommentVNode("", true),
        (_ctx.showFileUpload)
            ? (_openBlock(), _createBlock(_component_file_upload_modal, {
                key: 3,
                view: _ctx.viewType,
                show: _ctx.showFileUpload,
                "onUpdate:show": _cache[28] || (_cache[28] = ($event) => ((_ctx.showFileUpload) = $event)),
                uploadedFiles: _ctx.uploadedDragFiles,
                "onUpdate:uploadedFiles": _cache[29] || (_cache[29] = ($event) => ((_ctx.uploadedDragFiles) = $event)),
                onClose: _cache[30] || (_cache[30] = ($event) => (_ctx.uploadedDragFiles = []))
            }, null, 8, ["view", "show", "uploadedFiles"]))
            : _createCommentVNode("", true),
        (_ctx.showFolderUpload)
            ? (_openBlock(), _createBlock(_component_folder_upload_modal, {
                key: 4,
                view: _ctx.viewType,
                show: _ctx.showFolderUpload,
                "onUpdate:show": _cache[31] || (_cache[31] = ($event) => ((_ctx.showFolderUpload) = $event)),
                uploadedFiles: _ctx.uploadedDragFiles,
                "onUpdate:uploadedFiles": _cache[32] || (_cache[32] = ($event) => ((_ctx.uploadedDragFiles) = $event)),
                onSetFolder: _ctx.addNewFolder,
                onClose: _cache[33] || (_cache[33] = ($event) => (_ctx.uploadedDragFiles = []))
            }, null, 8, ["view", "show", "uploadedFiles", "onSetFolder"]))
            : _createCommentVNode("", true),
        (_ctx.showDeleteFile)
            ? (_openBlock(), _createBlock(_component_delete_file_modal, {
                key: 5,
                show: _ctx.showDeleteFile,
                "onUpdate:show": _cache[34] || (_cache[34] = ($event) => ((_ctx.showDeleteFile) = $event))
            }, null, 8, ["show"]))
            : _createCommentVNode("", true),
        (_ctx.changeItemName)
            ? (_openBlock(), _createBlock(_component_change_item_name_modal, {
                key: 6,
                show: _ctx.changeItemName,
                "onUpdate:show": _cache[35] || (_cache[35] = ($event) => ((_ctx.changeItemName) = $event))
            }, null, 8, ["show"]))
            : _createCommentVNode("", true),
        (_ctx.shareItem)
            ? (_openBlock(), _createBlock(_component_temporary_item_share_modal, {
                key: 7,
                show: _ctx.shareItem,
                "onUpdate:show": _cache[36] || (_cache[36] = ($event) => ((_ctx.shareItem) = $event))
            }, null, 8, ["show"]))
            : _createCommentVNode("", true)
    ], 64));
}
